export default (api) => {
    return {
        index: options => api.get('project_extensions', options),
        get: (challenge_code, options) => api.get(`project_extensions/${challenge_code}`, options)
    }
}
